module.exports = __webpack_public_path__ + "static/background-6893e224d352a95eccf589a7e16ed5b2.jpg";